/**
 * Holds all yasr plugin names.
 */
export const YasrPluginName = {
    'EXTENDED_TABLE': 'extended_table',
    'RAW_RESPONSE': 'response',
    'TABLE': 'table'
};
